import $api from "@/shared/http";
import { toApiError } from "@/shared/http/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreateOrderResponse, NewOrderResponseType } from "../../model/types";

export const createRemainsOrder = createAsyncThunk<
  NewOrderResponseType,
  void,
  { rejectValue: string }
>("cart/createRemainsOrder", async (_, { rejectWithValue }) => {
  try {
    const response = await $api.post<NewOrderResponseType>(
      "/order/create/basket/remains",
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

export const updateRemainsOrder = createAsyncThunk<
  CreateOrderResponse[],
  void,
  { rejectValue: string }
>("cart/updateRemainsOrder", async (_, { rejectWithValue }) => {
  try {
    const response = await $api.post<CreateOrderResponse[]>(
      "/order/update/basket/remains",
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});
